export const hashtagsPath = {
  /* inject path */
  TOP_POSTS: '/hashtags/top-posts',
  HASHTAG_VIEW: '/hashtags/hashtag-view/:id/:name?',
  HASHTAG_VIEW_URI: '/hashtags/hashtag-view',
  EDIT_HASHTAG_URI: '/hashtags/edit-hashtag',
  EDIT_HASHTAG: '/hashtags/edit-hashtag/:id',
  EDIT_HASHTAG_URI: '/hashtags/edit-hashtag',
  ADD_HASHTAG: '/hashtags/add-hashtag',
  TOP_MENTIONS: '/hashtags/top-mentions',
  HASHTAGS: '/hashtags/hashtags',
  COMPARE_HASHTAGS: '/hashtags/compare-hashtags',
  DASHBOARD: '/hashtags/dashboard',
  TOP_COUNTRIES_WORLD_MAP: '/hashtags/top-countries-map',
};
